import { Link } from 'react-router-dom';
import { SELLER } from '../../pages/Legal/sellerInfo';
import './Footer.css';

function MirLogo() {
  return (
    <svg className="sf-pay__mir" viewBox="0 0 56 16" aria-hidden="true">
      <rect x="0" y="2" width="14" height="12" rx="2" fill="#4DB45E" />
      <path d="M4 8h6M7 5v6" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" />
      <text x="18" y="12" fill="currentColor" fontSize="11" fontWeight="700" fontFamily="RazerF5, sans-serif">
        МИР
      </text>
    </svg>
  );
}

export default function Footer() {
  const s = SELLER;

  return (
    <footer className="site-footer">
      <div className="site-footer__inner container">
        <div className="site-footer__row">
          <nav className="sf-nav" aria-label="Навигация в подвале">
            <Link to="/catalog">Каталог</Link>
            <Link to="/delivery">Доставка</Link>
            <Link to="/oferta">Оферта</Link>
            <Link to="/privacy">Конфиденциальность</Link>
            <Link to="/cookies">Cookie</Link>
            <Link to="/contacts">Контакты</Link>
            <Link to="/return-memo">Возврат</Link>
          </nav>

          <div className="sf-contacts">
            <a href={`tel:${s.phoneTel}`}>{s.phoneDisplay}</a>
            <a href={`mailto:${s.email}`}>{s.email}</a>
            <span>{s.hours}</span>
          </div>
        </div>

        <div className="site-footer__row site-footer__row--bottom">
          <div className="sf-pay">
            <span className="sf-pay__label">Оплата</span>
            <a
              href="https://www.tbank.ru/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Т‑Банк"
            >
              <img src="/payments/tbank.png" alt="Т‑Банк" />
            </a>
            <MirLogo />
            <p className="sf-pay__note">
              Через защищённую форму{' '}
              <a href="https://www.tbank.ru/" target="_blank" rel="noopener noreferrer">
                Т‑Банка
              </a>
              , данные карты на сайте не хранятся.
            </p>
          </div>

          <p className="sf-meta">
            © {new Date().getFullYear()} {s.brand} · {s.name} · ИНН {s.inn} · ОГРНИП {s.ogrnip}
            <br />
            {s.address}
          </p>
        </div>
      </div>
    </footer>
  );
}
